import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { OpacityAnimation } from "./OpacityAnimation";
import { ValueWithRandom } from "../../ValueWithRandom";
import { setRangeValue } from "../../../../Utils/NumberUtils";
export var Opacity = /*#__PURE__*/function (_ValueWithRandom) {
  _inherits(Opacity, _ValueWithRandom);

  var _super = _createSuper(Opacity);

  function Opacity() {
    var _this;

    _classCallCheck(this, Opacity);

    _this = _super.call(this);
    _this.animation = new OpacityAnimation();
    _this.random.minimumValue = 0.1;
    _this.value = 1;
    return _this;
  }

  _createClass(Opacity, [{
    key: "anim",
    get: function get() {
      return this.animation;
    },
    set: function set(value) {
      this.animation = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _data$animation;

      if (!data) {
        return;
      }

      _get(_getPrototypeOf(Opacity.prototype), "load", this).call(this, data);

      var animation = (_data$animation = data.animation) !== null && _data$animation !== void 0 ? _data$animation : data.anim;

      if (animation !== undefined) {
        this.animation.load(animation);
        this.value = setRangeValue(this.value, this.animation.enable ? this.animation.minimumValue : undefined);
      }
    }
  }]);

  return Opacity;
}(ValueWithRandom);